import WATER_ACTIVITIES_REPOSITORY
    from '@/js/common/components/filterCriteria/waterActivities/WaterActivitiesRepository';
import getCustomerHash from '@/js/desktop/components/account/service/getCustomerHash';
import getHotelsWithoutOil from './getHotelsWithoutOil';

const trackingSearchFilters = async (options, uuid, filteredSearchUuid) => {
    const searchUuid = uuid;
    const availableOperators = options.filters?.operators?.getAvailableOperators();
    const filterCriteria = options.filters.model;
    const shouldZeroMinPrice = options.filters?.model?.get('minPrice') === 6000;
    const shouldZeroMaxPrice = options.filters?.model?.get('maxPrice') === 10000000 || options.filters?.model?.get('maxPrice') === 5000000;

    const filterCriteriaJson = {
        ...filterCriteria.toJSON(),
        minPrice: shouldZeroMinPrice ? 0 : options.filters?.model?.get('minPrice'),
        maxPrice: shouldZeroMaxPrice ? 0 : options.filters?.model?.get('maxPrice'),
    };

    filterCriteriaJson.exclusive = filterCriteriaJson.isExclusive;

    const attributeNames = [
        'freeCancellation',
        'children_animators',
        'children_seaEnter',
        'children_childmenu',
        'children_childBed',
        'children_nanny',
        'children_clubs',
        'withKids',
        // 'adultsOnly',
        'forCouples',
        'nearTheLift',
        'firstLine',
        'secondLine',
        'thirdLine',
        'beachOwner',
        'cashback',
        'airConditioner',
        'nearTheBeach',
        'nearTheCenter',
        // 'withAnimals',
        // 'mountains',
        // 'eco',
        'minPrice',
        'maxPrice',
        'best',
        'better',
        'good',
        'satisfactorily',
        'wifi',
        'wellness',
        'pool',
        'heatedPool',
        'aquapark',
        // 'spaAndHealth',
        'lonelyMan',
     ].concat(WATER_ACTIVITIES_REPOSITORY.map((item) => item.name));
    const attributes = _.mapObject(_.pick.apply(this, [filterCriteriaJson].concat(attributeNames)), (value) => +value);
    const operators = filterCriteria ? filterCriteria.get('operators') : null;
    let mergedOpeartors = [];

    const customerHash = await getCustomerHash();

    if (availableOperators) {
        const availableOperatorsId = _.pluck(availableOperators, 'id');

        mergedOpeartors = availableOperatorsId.reduce((prev, next) => {
            prev[next] = 0;
            return prev;
        }, {});

        mergedOpeartors = operators.reduce((prev, next) => {
            prev[next] = 1;
            return prev;
        }, mergedOpeartors);
    }

    const hotelsWithoutOil = options.filteredHotels?.reduce((count, hotel) => (
        hotel.get('oilTaxIsAbsent')
            ? count + 1
            : count
    ), 0);

    const noScore = filterCriteriaJson.typeFilterRating === 'allScore';

    return _.extend({}, {
        sandBeach: +(filterCriteriaJson.sandBeach || filterCriteriaJson.beachType === 'sandBeach'),
        pebbleBeach: +(filterCriteriaJson.pebbleBeach || filterCriteriaJson.beachType === 'pebbleBeach'),
        operators: mergedOpeartors,
        autoChange: +!!options.autoChange,
        hotelsLength: options.filteredHotels ? options.filteredHotels.length : undefined,
        hotelsWithoutOil,
        searchUuid,
        noScore: +noScore,
        uuid: filteredSearchUuid,
        renderTime: options.serpProductsRenderTime,
        customer_hash: customerHash,
    }, attributes, getHotelsWithoutOil(options.filteredHotels));
};

export default trackingSearchFilters;